import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from '@mui/material/CircularProgress';
import info from "Images/checkout/info.svg";
import { useDispatch } from "react-redux";
const ReferralCard = ({ state, discountStr, applyPromo, removePromo, numStored }) => {
    const dispatch = useDispatch();
    const label = state === "available" ? "Redeem" : "Remove";
    const [loading, setLoading] = useState(false);
    const explainText = state === "unavailable" ? "Stored Referral Credit" : "Referral Credit";
    let savedDiscountText = _jsx("span", {});
    if (discountStr?.length === 1) {
        savedDiscountText = (_jsxs("span", { children: ["You must remove your promo code (", _jsx("span", { style: { color: "#1e534d", fontWeight: 600 }, children: discountStr[0] }), ") to apply a referral credit."] }));
    }
    else if (discountStr?.length > 1) {
        const promoCodes = discountStr.join(", ");
        savedDiscountText = (_jsxs("span", { children: ["You must remove your promo codes (", _jsx("span", { style: { color: "#1e534d", fontWeight: 600 }, children: promoCodes }), ") to apply a referral credit."] }));
    }
    const apply = async () => {
        setLoading(true);
        await applyPromo("referral");
        setLoading(false);
    };
    const remove = async () => {
        setLoading(true);
        await removePromo("referral");
        setLoading(false);
    };
    const clickFunc = state === "available"
        ? () => {
            apply();
        }
        : () => {
            remove();
        };
    return (_jsxs("div", { className: `${styles.referralComponent} ${state === "unavailable" ? styles.greyBack : ""} ${state === "used" ? styles.greenBack : ""}`, children: [_jsxs("div", { children: [_jsx("h4", { className: styles.greenText, children: "40% off" }), _jsx("p", { className: styles.explainText, children: explainText })] }), loading ? (_jsx(CircularProgress, { size: 25, className: styles.spinner })) : (_jsxs("div", { children: [state !== "unavailable" &&
                        (discountStr?.length > 0 ? (_jsx(Tooltip, { title: savedDiscountText, children: _jsx("img", { className: styles.info_icon, src: info, alt: "info" }) })) : (_jsx(UnderlinedButton, { label: label, onClick: clickFunc }))), numStored &&
                        _jsxs("p", { className: styles.storedText, children: [numStored, " Stored Credit", numStored > 1 ? 's' : ''] })] }))] }));
};
export default ReferralCard;
